import React from "react";
import classNames from "classnames";

import styles from "./EditableTable.module.scss";

export interface EditableTableCellSelectionState {
    top: boolean;
    bottom: boolean;
    left: boolean;
    right: boolean;
    isInBuffer: boolean;
}

export interface EditableTableCellProps {
    id?: string;
    isFirstRow?: boolean;
    selectionState?: EditableTableCellSelectionState;
    error?: string;
    children?: React.ReactNode;
    className?: string;
    onClick?: () => void;
    draggable?: boolean;
}

type EditableTableCellDivProps = EditableTableCellProps &
    Omit<React.HTMLAttributes<HTMLDivElement>, keyof EditableTableCellProps>;

const EditableTableCellInner = ({
    id,
    className,
    isFirstRow,
    selectionState,
    children,
    error,
    onClick,
    draggable,
    ref,
    ...rest
}: EditableTableCellDivProps & { ref?: React.Ref<HTMLDivElement> }) => (
    <div
        data-test={id}
        key={id}
        ref={ref}
        onClick={onClick}
        className={classNames(
            styles.editableTableCell,
            isFirstRow && styles.editableTableCellNoTopBorder,
            selectionState && styles.editableTableCellSelected,
            error && styles.editableTableCellError,
            className,
        )}
        style={{
            cursor: draggable ? "grab" : undefined,
        }}
        {...rest}
    >
        {children}
    </div>
);

export const EditableTableCell = React.memo(EditableTableCellInner);
